module.exports = __webpack_public_path__ + "static/media/4374.7962b285.jpg";